"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthNBanner = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _AuthNBanner = require("./AuthNBanner.styles");
/** Component for rendering an authentication banner.
 * This banner is useful for rendering a login/logout UI for third-party EHR systems.
 * Arbitrary content is accepted by the component to allow for greater customization
 * and arbitrary placement within the direct-booking flow.
 * Accepted content:
 * - header: the main content describing the authentication purpose
 * - description: secondary content describing the authentication purpose
 * - action: component responsible for triggering the authentication flow
 * - separatorContent: optional content used to separate the banner from other content on the page
 */
const AuthNBanner = _ref => {
  let {
    children,
    header,
    description,
    action,
    separatorContent,
    'data-testid': dataTestId,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_AuthNBanner.Container, (0, _extends2.default)({
    "data-testid": dataTestId
  }, props), children ? children({
    header,
    description,
    action,
    separatorContent
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_AuthNBanner.InfoContainer, null, header, description), /*#__PURE__*/_react.default.createElement(_AuthNBanner.ActionContainer, null, action), separatorContent && (typeof separatorContent === 'string' ? /*#__PURE__*/_react.default.createElement(_AuthNBanner.Separator, {
    content: separatorContent
  }) : separatorContent)));
};
exports.AuthNBanner = AuthNBanner;
AuthNBanner.defaultProps = {};
AuthNBanner.propTypes = {
  /** Optional render prop for full customization. Exposes all other props. */
  children: _propTypes.default.func,
  /** the main content describing the authentication purpose */
  header: function (props, propName, componentName) {
    if (!props[propName] && !props.description) {
      return new Error(`Invalid props supplied. \`${propName}\` must be supplied to \`${componentName}\` if no \`description\` is supplied.`);
    }
    _propTypes.default.checkPropTypes({
      [propName]: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string])
    }, props, propName, componentName);
  },
  /** secondary content describing the authentication purpose */
  description: function (props, propName, componentName) {
    if (!props[propName] && !props.header) {
      return new Error(`Invalid props supplied. \`${propName}\` must be supplied to \`${componentName}\` if no \`header\` is supplied.`);
    }
    _propTypes.default.checkPropTypes({
      [propName]: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string])
    }, props, propName, componentName);
  },
  /** component responsible for triggering the authentication flow */
  action: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string]).isRequired,
  /** optional content used to separate the banner from other content on the page */
  separatorContent: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string]),
  'data-testid': _propTypes.default.string
};
AuthNBanner.__docgenInfo = {
  "description": "Component for rendering an authentication banner.\nThis banner is useful for rendering a login/logout UI for third-party EHR systems.\nArbitrary content is accepted by the component to allow for greater customization\nand arbitrary placement within the direct-booking flow.\nAccepted content:\n- header: the main content describing the authentication purpose\n- description: secondary content describing the authentication purpose\n- action: component responsible for triggering the authentication flow\n- separatorContent: optional content used to separate the banner from other content on the page",
  "methods": [],
  "displayName": "AuthNBanner",
  "props": {
    "children": {
      "description": "Optional render prop for full customization. Exposes all other props.",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "header": {
      "description": "the main content describing the authentication purpose",
      "type": {
        "name": "custom",
        "raw": "function (props, propName, componentName) {\n  if (!props[propName] && !props.description) {\n    return new Error(\n      `Invalid props supplied. \\`${propName}\\` must be supplied to \\`${componentName}\\` if no \\`description\\` is supplied.`\n    );\n  }\n  PropTypes.checkPropTypes(\n    {\n      [propName]: PropTypes.oneOfType([PropTypes.element, PropTypes.string])\n    },\n    props,\n    propName,\n    componentName\n  );\n}"
      },
      "required": false
    },
    "description": {
      "description": "secondary content describing the authentication purpose",
      "type": {
        "name": "custom",
        "raw": "function (props, propName, componentName) {\n  if (!props[propName] && !props.header) {\n    return new Error(\n      `Invalid props supplied. \\`${propName}\\` must be supplied to \\`${componentName}\\` if no \\`header\\` is supplied.`\n    );\n  }\n  PropTypes.checkPropTypes(\n    {\n      [propName]: PropTypes.oneOfType([PropTypes.element, PropTypes.string])\n    },\n    props,\n    propName,\n    componentName\n  );\n}"
      },
      "required": false
    },
    "action": {
      "description": "component responsible for triggering the authentication flow",
      "type": {
        "name": "union",
        "value": [{
          "name": "element"
        }, {
          "name": "string"
        }]
      },
      "required": true
    },
    "separatorContent": {
      "description": "optional content used to separate the banner from other content on the page",
      "type": {
        "name": "union",
        "value": [{
          "name": "element"
        }, {
          "name": "string"
        }]
      },
      "required": false
    },
    "data-testid": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};